module.exports = "<div class=\"form-control component-correspondence-control\"> {{#if unvisible}} <p class=info>权限受限</p> {{else if be_control_condition}} <p class=info>被修改条件限制</p> {{else}} <a href=javascript:void(0); class=ui-forms-a><i class=\"corr-img icon-correspondence form-icon\"></i><span>对应关系</span></a> <div class=ui-correspondence-box> <div class=correspondence-box></div> </div> {{#if required}} <span id=requiredLogo class=\"required form-print-icon\"></span> {{/if}} {{/if}} </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/correspondence-control/correspondence-control.html
// module id = 4721
// module chunks = 50